import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IPageContent, ICommonPageContent } from "app/api/types";
import {
  getPageContentById,
  editPageContent,
} from "app/api/redux/PageContent/actions";
import LayoutUser from "app/components/LayoutUser";

import ContentGroup from "app/components/ContentGroup";
import {
  Notification,
  INotificationType,
} from "app/components/Elements/Notification";

import "./styles.scss";

interface IProps extends RouteComponentProps<{ id: string }> {
  currentPage: IPageContent;
  isLoading: boolean;
  getPageContentById: (id: string) => Promise<AxiosResponse>;
  editPageContent: (data: IPageContent) => Promise<AxiosResponse>;
}

interface IState {
  pageId: string;
  pageTitle: string;
  content: ICommonPageContent[];
  notification: { type: INotificationType; message: string };
}

const initialNotification = {
  type: INotificationType.NONE,
  message: "",
};

interface INotificationMessage {
  onError: string;
  onSuccess: string;
}
class PageContentPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      pageId: "",
      pageTitle: "",
      content: [],
      notification: initialNotification,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    this.props
      .getPageContentById(id)
      .then((res) =>
        this.setState({
          ...this.props.currentPage,
          notification: this.state.notification,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  }

  handleChange = (e: any) => {
    const targetName: string[] = e.target.name.split("--"); //отделяет id content'а от типа поля (src напр.)
    const targetValue = e.target.value;
    let obj: any = {};

    const newContent = this.state.content.map((content: ICommonPageContent) => {
      if (content.id === targetName[0]) {
        obj[targetName[1]] = targetValue;
        return {
          ...content,
          ...obj,
        };
      }

      return content;
    });

    this.setState({ content: newContent });
  };

  onSubmit = () => {
    const data = {
      pageId: this.props.currentPage.pageId,
      pageTitle: this.props.currentPage.pageTitle,
      content: this.state.content,
    };

    const message: INotificationMessage = {
      onSuccess: "Данные успешно сохранены",
      onError: "ОШИБКА: Данные не сохранены",
    };

    this.editPageContent(data, message);
  };

  editPageContent = (data: IPageContent, message: INotificationMessage) => {
    this.setState({ notification: initialNotification });

    this.props
      .editPageContent(data)
      .then((res) =>
        this.setState({
          notification: {
            type: INotificationType.SUCCESS,
            message: message.onSuccess,
          },
        })
      )
      .catch((err) =>
        this.setState({
          notification: {
            type: INotificationType.ERROR,
            message: message.onError,
          },
        })
      );
  };

  addItem = () => {
    let itemId = "";
    const pageId = this.state.pageId;

    try {
      const splitedId = this.state.content[
        this.state.content.length - 1
      ].id.split("-");

      if (isNaN(Number(splitedId[splitedId.length - 1])))
        itemId = `${pageId}_item-1`;
      else
        itemId = `${pageId}_item-${
          Number(splitedId[splitedId.length - 1]) + 1
        }`;

      //просто будем надеяться что никто не запушит плохого id
    } catch (err) {
      itemId = `${pageId}_item-1`;
    }

    const item =
      pageId !== "portfolio"
        ? {
            id: itemId,
            src: "",
            title: "Продукт(224x210)",
            name: "",
            status: "",
            description: "",
            shortDescription: "",
            price: "",
          }
        : {
            id: itemId,
            title: "Изображение(350x350)",
            src: "",
          };

    this.setState({
      content: [...this.state.content, item],
    });
  };

  deleteItem = (id: string) => {
    const newContent = this.state.content.filter(
      (content) => content.id !== id
    );
    this.setState(
      {
        content: newContent,
      },
      () => this.onSubmit()
    );
  };

  render() {
    const isSpecialPage =
      this.state.pageId.match(/\b(\w*shop\w*)\b/g) ||
      this.state.pageId === "portfolio";

    return (
      <LayoutUser>
        <div className="current-page__header">
          <p className="curent-page__title">{this.state.pageTitle}</p>
          {isSpecialPage && (
            <button className="label__add-button" onClick={this.addItem} />
          )}
        </div>
        {this.state.content.map((content: ICommonPageContent) => (
          <ContentGroup
            content={content}
            onDelete={isSpecialPage ? this.deleteItem : null}
            handleSubmit={this.onSubmit}
            handleChange={this.handleChange}
            key={content.id}
          />
        ))}
        <button className="edit-phrase__submit" onClick={this.onSubmit}>
          cохранить
        </button>
        {this.state.notification.message && (
          <Notification
            type={this.state.notification.type}
            message={this.state.notification.message}
          />
        )}
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentPage: state.pageContents.currentPage[0],
    isLoading: state.pageContents.isLoading,
  };
};

export default withRouter(
  connect(mapStateToProps, { getPageContentById, editPageContent })(
    PageContentPage
  )
);
